module.exports = __webpack_public_path__ + "img/img_clients5.dfd3a821.jpg";